import React from "react";
import { useDispatch } from "react-redux";
import './MahutiActivitiesItem.css'
import { setSelectedActivity } from "../../store/MahutiReducer";
import { isMobile } from "react-device-detect";
import { mySteps } from "../../utils/stepperUtils";
import RadioChecked from "../../svg/radioChecked";
import RadioEmpty from "../../svg/radioEmpty";


export default function MahutiActivitiesItem(props) {

    const dispatch = useDispatch();
    const ageStr = (props.kindergarden__c && props.school__c) ? 'גילאי 4-12' : props.kindergarden__c ? 'גילאי 4-7' : props.school__c ? 'גילאי 7-12' : '';
    const inputOnChange = (e) => {
        mySteps[props.currentStep].disabled = false;
        dispatch(setSelectedActivity(props))
    }

    return <div className={`MahutiActivitiesItem mb-0 mb-lg-3 overflow-hidden card rounded-0 ${!props.lastItem && 'border_bottom_line'} ${props.isRecommended && 'mahuti-light'}`} >

{isMobile ? <div className="px-1 py-4">
                {false && <span className="badge badge-info z-index text-danger">Danger</span>}
                {props.isRecommended && <div className="ribbon ">
                    <div className="ribbon-container alef">
                        <span>מומלץ</span>
                    </div>
                </div>}
                <div className="row header-card-title text-bolder align-items-center">
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <label className="pointer d-flex" htmlFor={props.lineId}>{props.isSelected ? <RadioChecked/> : <RadioEmpty/>}</label>
                        <input id={props.lineId} className='invisible position-absolute inputWrapper_mobile' type="radio" name="flexRadioDisabled" checked={props.isSelected} onChange={(e) => inputOnChange(e)} />
                        <span className="justify-content-start text-mahuti" htmlFor="flexRadioDisabled">
                            <strong>{props.Title}</strong>
                        </span>
                        {ageStr && <span className="text-mahuti gap-2 align-items-center d-flex">{ageStr}</span>}
                    </div>

                </div>
                <div className="row gx-3">
                    <div className="col-4">
                        <img src={props.cartImage} width='80' height='80' className="rounded border-0" alt="..." />
                    </div>
                    <div className="col-8">
                        <p className="text-mahuti text-start pr-1">
                            {props.shortDescription__c}
                        </p>
                    </div>

                </div>
            </div>:
            <div>
                {props.isRecommended && <div className="ribbon ">
                    <div className="ribbon-container alef text-mahuti"> 
                        <span>מומלץ</span>
                    </div>
                </div>}
                <div className="card-body">
                    {false && <span className="badge badge-info z-index text-danger">Danger</span>}
                    <div className="row align-items-center justify-content-center">
                        <div className="inputWrapper col-1 d-flex justify-content-end">
                            <label className="pointer" htmlFor={props.lineId}>{props.isSelected ? <RadioChecked/> : <RadioEmpty/>}</label>
                            <input id={props.lineId} className="invisible position-absolute btn-sm text-center " type="radio" name="radioMahutiActivity" checked={props.isSelected} onChange={(e) => inputOnChange(e)} />
                        </div>
                        <div className="col-2 d-flex align-items-start">
                            <img src={props.cartImage} width='75' height='75' className="rounded border-0" alt="..." />
                        </div>
                        <div className="col-3 text-start top_space_m_8">
                            <span className="header-detail">{props.Title}</span>
                            {ageStr && <p className="sub-header text-mahuti mb-0">{ageStr}</p>}
                        </div>
                        <div className="col-6 d-flex justify-content-center align-items-center ">
                            <p className="description text-mahuti mb-0 text-start">
                                {/* {props.description?.substring(0, 85).concat('...')} */}
                                {props.shortDescription__c}
                            </p>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
}